<ng-container *ngIf="isAcmic; else MAState">
    <ng-template #fallbackDiv>
        <div class="bn-alert-notice bn-info-notice acmic-upcoming-radius" *ngIf="showSevenDayNotice && currentMinAmtDue !==0 && !suppressAutoPayScheduledNotice">
            <div class="bn-icon">
                <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
            </div>
            <div class="bn-content">
                <div class="bn-payment-content-text">
                    <div class="payment-content-text-sub">
                        <div class="upcoming-payment-text-title">Upcoming Payment due on {{ paymentDate |customDateFormat}}</div>
                            <img src="./assets/img/images/icon-close-18.svg" 
                             class="upcoming-payment-cursor" 
                             alt="close icon"
                             (click)="onClose()"/>
                        </div>
                        <div class="payment-content-desc">
                            <div>
                                <div class="bn-pastdue-desc-acmic">
                                    <p *ngIf="currentMinAmtDue !==undefined" class="bn-pastdue-content-desc">Amount:</p><strong class="pastdue-payment-strong-one">{{currentMinAmtDue | currency}}</strong>
                                </div>
                            </div>
                            <div class="upcoming-pay-btn">
                                <mapfre-button 
                                    [inputType]="'submit'"
                                    [ngClass]="{'custom_loader': loading}" 
                                    [additionalClasses]="'basic primary payment-paynow-action-btn'"
                                    [translateValue]="'Pay now'"
                                    (click)="payNow()">
                                </mapfre-button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bn-alert-notice bn-info-notice acmic-upcoming-radius" *ngIf="showTodayNotice && currentMinAmtDue !==0 && !suppressAutoPayScheduledNotice">
            <div class="bn-icon">
                <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
            </div>
            <div class="bn-content">
                <div class="bn-payment-content-text">
                    <div class="payment-content-text-sub">
                        <div class="upcoming-payment-text-title">Upcoming Payment due today, {{ paymentDate | customDateFormat}}</div>
                            <img src="./assets/img/images/icon-close-18.svg" 
                             class="upcoming-payment-cursor" 
                             alt="close icon"
                             (click)="onClose()" />                   
                        </div>
                        <div class="payment-content-desc">
                            <div>
                                <div class="bn-pastdue-desc-acmic">
                                    <p *ngIf="currentMinAmtDue !==undefined" class="bn-pastdue-content-desc">Amount:</p><strong class="pastdue-payment-strong-one">{{currentMinAmtDue | currency}}</strong>
                                </div>
                            </div>
                        <div class="upcoming-pay-btn">
                            <mapfre-button 
                                [inputType]="'submit'"
                                [ngClass]="{'custom_loader': loading}" 
                                [additionalClasses]="'basic primary payment-paynow-action-btn'"
                                [translateValue]="'Pay now'"
                                (click)="payNow()">
                            </mapfre-button>
                        </div>
                        </div>      
                </div>
            </div>
        </div>
        <div class="payment-notice margin-bottom mb24 acmic-upcoming-radius" *ngIf="pastDueNotice && policy?.policyStatus !== 'CANCELLED' && currentMinAmtDue !==0">
            <div class="icon">
                <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
            </div>
            <div class="notice-main-row">
                <div class="policy-notice-infor">
                    <div class="payment-title-sec">
                        <div class="payment-notice-text">
                            Payment is past due and may result in cancellation if not paid by {{nineDaysPastDue}}
                        </div>
                        <img src="./assets/img/images/icon-close-18.svg" class="upcoming-payment-cursor" alt="close icon"
                                (click)="onClose()" />
                    </div>
                </div>                
                <div>
                    <div class="bn-pastdue-desc">
                        <p *ngIf="currentMinAmtDue !==undefined" class="bn-pastdue-content-acmic">Amount:</p>
                        <strong class="pastdue-payment-strong">{{ currentMinAmtDue | currency}}</strong>
                    </div>
                </div>
                <div class="upcoming-hr">
                    <svg xmlns="http://www.w3.org/2000/svg" max-width="746" width="100%" height="2" viewBox="0 0 746 2" fill="none">
                        <path d="M746 1L1.52588e-05 0.999967" stroke="#CCCCCC"/>
                      </svg>
                </div>
                
                <div class="payment-contact-desc ">
                    Contact us for assistance
                </div>
                <div class="agent-info-upcoming agent-info">
                    <div class="payment-contact agent-tel">
                        Phone<a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text agent-number">
                            {{ agentPhoneNumber | formatPhone }}</a>
                    </div>
                </div>
            </div>
        </div> 
    </ng-template>
    <div class="bn-alert-notice bn-info-notice" *ngIf="((showSevenDayNotice || showTodayNotice) && currentMinAmtDue!==0 && policy?.policyFlags.isEftEligible === 'Y' && policy?.policyFlags.isEft === 'ENROLLED' && !suppressAutoPayScheduledNotice); else fallbackDiv">
        <div class="bn-icon">
            <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
        </div>
        <div class="bn-content">
            <div class="bn-payment-content-text">
                <div class="payment-content-text-sub">
                    <div class="upcoming-payment-text-title">Automatic payment of {{currentMinAmtDue | currency}} has been scheduled on {{ paymentDate | customDateFormat }}</div>
                    <div class="bn-content-close">
                        <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer upcoming-close" alt="close icon"
                            (click)="onClose()" />
                    </div>
                </div>
                <div class="payment-content-desc">
                    <p class="margin-bottom mb0">No further action is required.</p>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #MAState>
    <ng-template #fallbackDiv>
        <div class="bn-alert-notice bn-info-notice" *ngIf="showSevenDayNotice && currentMinAmtDue !==0 && !suppressAutoPayScheduledNotice" >
            <div class="bn-icon">
                <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
            </div>
            <div class="bn-content">
                <div class="bn-payment-content-text">
                    <div class="payment-content-text-sub">
                        <div class="upcoming-payment-text-title">Upcoming Payment due on {{ paymentDate | customDateFormat  }}</div>
                            <img src="./assets/img/images/icon-close-18.svg" 
                             class="upcoming-payment-cursor" 
                             alt="close icon"
                             (click)="onClose()"/>
                        </div>
                        <div class="payment-content-desc">
                            <div class="bn-payment-content-desc">
                            <p *ngIf="currentMinAmtDue !==undefined" class="bn-payment-content-desc-p">Amount: 
                                <strong class="payment-strong">{{ currentMinAmtDue | currency}}</strong></p>
                            </div>
                            <div class="upcoming-pay-btn">
                                <mapfre-button 
                                    [inputType]="'submit'"
                                    [ngClass]="{'custom_loader': loading}" 
                                    [additionalClasses]="'basic primary payment-paynow-action-btn'"
                                    [translateValue]="'Pay now'"
                                    (click)="payNow()">
                                </mapfre-button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bn-alert-notice bn-info-notice" *ngIf="showTodayNotice && currentMinAmtDue !==0 && !suppressAutoPayScheduledNotice">
            <div class="bn-icon">
                <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" class="upcoming-info-icon" />
            </div>
            <div class="bn-content">
                <div class="bn-payment-content-text">
                    <div class="payment-content-text-sub">
                        <div class="upcoming-payment-text-title">Upcoming Payment due today, {{ paymentDate | customDateFormat}}</div>
                            <img src="./assets/img/images/icon-close-18.svg" 
                             class="upcoming-payment-cursor" 
                             alt="close icon"
                             (click)="onClose()" />                   
                        </div>
                        <div class="payment-content-desc">
                            <div class="bn-payment-content-desc">
                            <p class="bn-payment-content-desc-p" *ngIf="currentMinAmtDue !==undefined">Amount: 
                                <strong class="payment-strong">{{ currentMinAmtDue | currency}}</strong></p>
                        </div> 
                        <div class="upcoming-pay-btn">
                            <mapfre-button 
                                [inputType]="'submit'"
                                [ngClass]="{'custom_loader': loading}" 
                                [additionalClasses]="'basic primary payment-paynow-action-btn'"
                                [translateValue]="'Pay now'"
                                (click)="payNow()">
                            </mapfre-button>
                        </div>
                    </div>           
                </div>
            </div>
        </div>   
        <div class="payment-notice margin-bottom mb24" *ngIf="pastDueNotice && policy?.policyStatus !== 'CANCELLED' && currentMinAmtDue !==0  && (policy?.policyFlags?.isEft === 'UNENROLLED' || policy?.policyFlags?.isEft === 'FALSE')">
            <div class="icon">
                <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
            </div>
            <div class="notice-main-row">
                <div class="policy-notice-infor">
                    <div class="payment-title-sec">
                        <div class="payment-notice-text">
                            Payment is past due and may result in cancellation if not paid by {{nineDaysPastDue}}
                        </div>
                        <img src="./assets/img/images/icon-close-18.svg" class="upcoming-payment-cursor" alt="close icon"
                                (click)="onClose()" />
                    </div>
                </div>                
                <div>
                    <div class="bn-pastdue-desc">
                        <p *ngIf="currentMinAmtDue !==undefined" class="bn-pastdue-content-desc">Amount:</p>
                        <strong class="pastdue-payment-strong">{{ currentMinAmtDue | currency}}</strong>
                    </div>
                </div>
                <div class="upcoming-hr">
                    <svg xmlns="http://www.w3.org/2000/svg" max-width="898" width="100%" height="2" viewBox="0 0 898 2" fill="none">
                        <path d="M898 1L2.28882e-05 0.999968" stroke="#E8EBED"/>
                      </svg>
                </div>
                    <div class="payment-contact-desc ">
                        Contact your agent for assistance
                    </div>

                    <div class="agent-info-upcoming agent-info">{{ policy?.agent?.agentName }}
                    <div class="payment-contact agent-tel">
                        <p class="agent-payment-phone">Phone<a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text agent-number">
                                {{ agentPhoneNumber | formatPhone }}</a>
                        </p>
                    </div>
                </div>
            
            </div>
        </div>
    </ng-template>
    <div class="bn-alert-notice bn-info-notice" *ngIf="((showSevenDayNotice || showTodayNotice) && currentMinAmtDue!==0 && policy?.policyFlags.isEftEligible === 'Y' && policy?.policyFlags.isEft === 'ENROLLED' && !suppressAutoPayScheduledNotice); else fallbackDiv">
        <div class="bn-icon">
            <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
        </div>
        <div class="bn-content">
            <div class="bn-payment-content-text">
                <div class="payment-content-text-sub">
                    <div class="upcoming-payment-text-title">Automatic payment of {{currentMinAmtDue | currency}} has been scheduled on {{ paymentDate | customDateFormat}}</div>
                    <div class="bn-content-close">
                        <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer upcoming-close" alt="close icon"
                            (click)="onClose()" />
                    </div>
                </div>
                <div class="bn-content-desc">
                    <p class="margin-bottom mb0">No further action is required.</p>
                </div>
            </div>
        </div>
    </div> 
</ng-template>